import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoonIcon = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.7202 9.23583C14.6578 9.17354 14.579 9.13022 14.4929 9.1109C14.4069 9.09157 14.3171 9.09703 14.234 9.12664C13.1175 9.5247 11.9111 9.59779 10.7547 9.33742C9.59834 9.07705 8.53961 8.49391 7.70149 7.65575C6.86338 6.81759 6.2803 5.75882 6.02 4.60245C5.7597 3.44608 5.83286 2.23958 6.23098 1.12314C6.26057 1.04005 6.26599 0.950271 6.24663 0.864218C6.22727 0.778165 6.18392 0.699362 6.1216 0.636944C6.05928 0.574526 5.98054 0.53105 5.89452 0.511555C5.8085 0.49206 5.71871 0.497346 5.63557 0.526799C4.62902 0.882243 3.71558 1.4601 2.96323 2.21737C1.61452 3.56711 0.857061 5.39723 0.857422 7.30532C0.857783 9.21341 1.61593 11.0432 2.96515 12.3925C4.31438 13.7417 6.14421 14.4998 8.05231 14.5002C9.9604 14.5006 11.7905 13.7431 13.1403 12.3944C13.8976 11.6419 14.4754 10.7283 14.8308 9.72159C14.8602 9.63844 14.8654 9.54869 14.8458 9.46272C14.8262 9.37675 14.7827 9.29808 14.7202 9.23583Z",
		fill: "#111111"
	})
});
const ForwardRef = forwardRef(SvgMoonIcon);
export default ForwardRef;
